<template>
    <v-flex xs12 >
    <v-text-field
        ref="queryElement"
        v-if="spechRecAvailable"
        solo
        light
        append-icon="mic_none"
        @click:append="onClickMic"
        @keyup.enter.native="onQueryEnter"
        style="position:absolute;z-index: 2;top: 60px;margin-left: 3%; width: 90%"
        v-model="queryInput"
        :label="queryLabel"
    ></v-text-field>
    <!-- iOS13 holds the shift key on enter-->
    <v-text-field
        ref="queryElement"
        v-if="!spechRecAvailable"
        solo
        light
        @keyup.enter="onQueryEnter"
        style="position:absolute;z-index: 2;margin-top: 60%;margin-left: 3%; width: 90%"
        v-model="queryInput"
        label="Type here (try Chrome on desktop to enable speech recognition!)"
    ></v-text-field>
    </v-flex>
</template>

<script>
import {SmoothContext} from 'smooth-script'
import helper from '../../helper'
export default {
  name: 'text-input',
  data () {
    return {
      queryInput: '',
      queryStatus: 'Type Here...',
      displayTextBar: false,
      recognition: null,
      recognitionLanguage: null,
      timeRecognitionStarted: null,
      timeLastSwitched: null,
      allRecognitionResults: ''
    }
  },
  computed: {
    queryLabel () {
      if (this.queryInput.length === 0) {
        return this.queryStatus
      }
      return ''
    },
    spechRecAvailable () {
      return 'webkitSpeechRecognition' in window
    }
  },
  methods: {
    onClickMic () {
      this.switchRecognition()
    },
    isListening () {
      return this.spechRecAvailable && this.recognition
    },
    stopRecognitionEffects () {
      this.recognition = null
      this.queryStatus = 'Type Here...'
    },
    stopRecognition () {
      if (this.recognition) {
        if (this.spechRecAvailable) {
          this.recognition.stop()

          // Set the allRecognitionResults string to something so we don't think the recognition "timed out" without results
          this.allRecognitionResults = 'stopped voluntarily'
        }
        this.stopRecognitionEffects()
      }
    },
    startRecognition (locale) {
      if (!this.spechRecAvailable) {
        this.recognition = 1 // We use recognition as a test if we are waiting for input
        return
      }
      if (!locale) {
        if (!this.recognitionLanguage) {
          throw new Error('locale not specified')
        } else {
          locale = this.recognitionLanguage
        }
      } else {
        this.recognitionLanguage = locale
      }

      // eslint-disable-next-line new-cap
      this.recognition = new window.webkitSpeechRecognition()
      this.recognition.interimResults = true

      var timeRecognitionStarted = Date.now()
      this.allRecognitionResults = ''
      ;((time) => {
        this.recognition.onstart = (event) => {
          this.queryStatus = 'Listening to microphone...'
        }
        this.recognition.onresult = (event) => {
          if (!this.speechRecognitionPermissionGranted) {
            this.speechRecognitionPermissionGranted = true
            if (helper.isLocalStorageAvailable()) {
              window.localStorage.setItem('webkitSpeechRecognitionPermission', '1')
            }
          }
          if (this.recognition == null) {
            return
          }
          var text = ''
          var isFinal = false
          for (var i = event.resultIndex; i < event.results.length; ++i) {
            text += event.results[i][0].transcript
            if (event.results[i].isFinal) {
              isFinal = true
              break
            }
          }
          this.allRecognitionResults += text
          this.queryInput = text
          this.$emit('input', {
            text: this.queryInput,
            bIsFinal: isFinal })
        }
        this.recognition.onend = () => {
          var diff = Date.now() - time

          if (diff < 5) {
            this.$emit('blocked')
          } else if (this.allRecognitionResults.length === 0) {
            if (diff > 2000) {
              // Make sure we waited at least 2 seconds for results
              this.$emit('timeout')
            } else {
              console.warn('Something caused recognition to end prematurely, but allRecognitionResults was still empty')
            }
          }
          this.stopRecognitionEffects()
        }
      })(timeRecognitionStarted)

      this.recognition.lang = locale
      this.recognition.start()
    },
    switchRecognition (locale) {
      var newTimeLastSwitched = Date.now()
      if (newTimeLastSwitched - this.timeLastSwitched > 200) {
        this.timeLastSwitched = newTimeLastSwitched
        if (this.recognition) {
          this.stopRecognition()
        } else {
          this.startRecognition(locale)
        }
      } else {
        console.log('switchRecognition called too quickly to do anything')
      }
    },
    onQueryEnter () {
      this.$emit('input', {
        text: this.queryInput,
        bIsFinal: true })
    },
    onStartListening: function (locale) {
      if (!this.recognition && locale) {
        this.switchRecognition(locale)
      }
    },
    onStopListening: function () {
      if (this.recognition) {
        this.stopRecognition()
      }
      setTimeout(() => {
        this.queryInput = ''
      }, 300)
    }
  },
  created: function () {
    SmoothContext.eventEmitter.addListener('startListening', this.onStartListening)
    SmoothContext.eventEmitter.addListener('stopListening', this.onStopListening)

    // Warm the system up to prevent delayed recofnition on first response
    // @todo: do special message when we need permission
    if (helper.isLocalStorageAvailable()) {
      this.speechRecognitionPermissionGranted = window.localStorage.getItem('webkitSpeechRecognitionPermission')
    }

    if (this.speechRecognitionPermissionGranted) {
      // eslint-disable-next-line new-cap
      var startupRecognition = new window.webkitSpeechRecognition()
      startupRecognition.onstart = (event) => {
        startupRecognition.stop()
      }
      startupRecognition.start()
    }
  },
  beforeDestroy: function () {
    SmoothContext.eventEmitter.removeListener('startListening', this.onStartListening)
    SmoothContext.eventEmitter.removeListener('stopListening', this.onStopListening)
  },
  mounted: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Playback/TextInput.vue